import {Box} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppConfirmationDialog, AppConfirmationDialogRefType} from 'components/dialogs';
import {AppMenu} from 'components/menus';
import {AppTooltip} from 'components/toolip';
import {useRemoveItemDatasByIds} from 'hooks';
import {ItemDataResponse} from 'models/board';
import React, {useEffect, useRef, useState} from 'react';
import {AiOutlineDelete, AiOutlineEdit} from 'react-icons/ai';
import {BiTransferAlt} from 'react-icons/bi';
import {CiMenuKebab} from 'react-icons/ci';
import {IoIosTimer} from 'react-icons/io';
import {
    BoardViewTransferToAnotherBoardDialog,
    BoardViewUpdateSprintDialog,
    BoardViewUpdateStatusDialog,
} from './Dialogs';
interface TableViewMultiRowSelectedActionsProps {
    selectedRows: ItemDataResponse[];
    refreshTableData: () => void;
}
enum boardTableViewActions {
    UPDATE_STATUS = 'UPDATE_STATUS',
    UPDATE_SPRINT = 'UPDATE_SPRINT',
    TRANSFER_TO_OTHER_BOARD = 'TRANSFER_TO_OTHER_BOARD',
    DELETE = 'DELETE',
}
export interface BoardTableViewActionsCommonProps {
    selectedRows: ItemDataResponse[];
    onClose: (shouldRefresh?: boolean) => void;
    open: boolean;
}
export const TableViewMultiRowSelectedActions: React.FC<TableViewMultiRowSelectedActionsProps> = ({
    selectedRows,
    refreshTableData,
}) => {
    const [selectedAction, setSelectAction] = useState<boardTableViewActions>();
    const confimationDailogRef = useRef<AppConfirmationDialogRefType>(null);
    const handleConsole = (shouldRefresh?: boolean) => {
        setSelectAction(undefined);
        if (shouldRefresh) {
            refreshTableData();
        }
    };
    const {removeItemDatasById, removeItemDatasByIdLoading, removeItemDatasByIdResponse} = useRemoveItemDatasByIds();
    useEffect(() => {
        if (!removeItemDatasByIdLoading && removeItemDatasByIdResponse) {
            if (confimationDailogRef.current) confimationDailogRef.current?.handleClose();
            handleConsole(true);
        }
    }, [removeItemDatasByIdLoading, removeItemDatasByIdResponse]);

    return (
        <>
            {selectedAction === boardTableViewActions.UPDATE_STATUS && (
                <BoardViewUpdateStatusDialog
                    selectedRows={selectedRows}
                    onClose={handleConsole}
                    open={selectedAction === boardTableViewActions.UPDATE_STATUS}
                />
            )}

            <AppConfirmationDialog
                ref={confimationDailogRef}
                title="Delete Items"
                description={`Are you sure you want to delete ${selectedRows.length} items?`}
                renderElement={() => {
                    return <></>;
                }}
                footerProps={{
                    submitButtonProps: {
                        isLoading: removeItemDatasByIdLoading,
                        disabled: removeItemDatasByIdLoading,
                    },
                    onCancelClick: () => {
                        confimationDailogRef.current?.handleClose();
                    },
                    onSubmitClick: () => {
                        removeItemDatasById(selectedRows.map(row => row.id));
                    },
                }}
            />
            {selectedAction === boardTableViewActions.UPDATE_SPRINT && (
                <BoardViewUpdateSprintDialog
                    selectedRows={selectedRows}
                    onClose={handleConsole}
                    open={selectedAction === boardTableViewActions.UPDATE_SPRINT}
                />
            )}
            {selectedAction === boardTableViewActions.TRANSFER_TO_OTHER_BOARD && (
                <BoardViewTransferToAnotherBoardDialog
                    selectedRows={selectedRows}
                    onClose={handleConsole}
                    open={selectedAction === boardTableViewActions.TRANSFER_TO_OTHER_BOARD}
                />
            )}
            {selectedRows.length > 0 && (
                <AppMenu
                    menuItems={[
                        {
                            label: 'Update Status',
                            icon: <AiOutlineEdit size={18} />,
                            onClick: () => {
                                setSelectAction(boardTableViewActions.UPDATE_STATUS);
                                // handle delete action
                            },
                        },
                        {
                            label: 'Update Sprint',
                            icon: <IoIosTimer size={18} />,
                            onClick: () => {
                                setSelectAction(boardTableViewActions.UPDATE_SPRINT);
                                // handle delete action
                            },
                        },
                        {
                            label: 'Transfer to other board',
                            icon: <BiTransferAlt size={18} />,
                            onClick: () => {
                                setSelectAction(boardTableViewActions.TRANSFER_TO_OTHER_BOARD);
                                // handle delete action
                            },
                        },
                        {
                            label: 'Delete',
                            icon: <AiOutlineDelete size={18} />,
                            onClick: () => {
                                if (confimationDailogRef.current) {
                                    confimationDailogRef.current.handleOpen();
                                }
                                setSelectAction(boardTableViewActions.DELETE);
                            },
                        },
                    ]}
                    icon={(onClick: React.MouseEventHandler<HTMLButtonElement>) => (
                        <Box ml={1}>
                            <AppTooltip title="Actions">
                                <AppIconButton onClick={onClick} size="small">
                                    <CiMenuKebab />
                                </AppIconButton>
                            </AppTooltip>
                        </Box>
                    )}
                />
            )}
        </>
    );
};

export default TableViewMultiRowSelectedActions;
